(function () {
    angular
      .module('kareo.ui.shared.directives.k-focus-on', [])
      .directive('sharedFocusOn', sharedFocusOn);
  
      sharedFocusOn.$inject = ['$timeout'];
  
    function sharedFocusOn($timeout) {
      return {
        restrict: 'A',
        scope: {
          trigger: '=sharedFocusOn'
        },
        link
      };
  
      function link(scope, element) {
        const input = element[0];
  
        scope.$watch('trigger', (value) => {
          if (value === true) {
            $timeout(() => {
              input.focus();
              scope.trigger = false;
            });
          }
        });
      }
    }
  })();